import ApiService from "services/ApiService";
import ApiRequestService from "services/ApiRequestService";

export const EmployeeAssessmentsService = {
    getOptions() {
        return new Promise((resolve, reject) => {
            ApiService.get(
                '/employee/Options/EmployeeAssessments'
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getStats(locationIds) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                '/employee/EmployeeAssessments/Stats/Search',
                { locationIds }
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getEmployeeOverviews(request) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                '/employee/EmployeeAssessments/Employees/Search',
                request
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    searchForEmployee(employeeId, request) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/EmployeeAssessments/Employee/${employeeId}/Search`,
                request
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    // Anonymous endpoint backing the emailed training link. Every value comes off the query string,
    // so each is encoded before it is put back into one.
    getTrainingLaunch(employeeId, trainingId, code) {
        return ApiRequestService.get(
            "employee",
            `EmployeeAssessments/Training/Launch?employee=${encodeURIComponent(employeeId)}&training=${encodeURIComponent(trainingId)}&code=${encodeURIComponent(code)}`
        );
    }
};